import { publicClient, privateClient } from './client';
import { StoreLocator } from './StoreLocator';

const transactionsStoreLocator = (pub: boolean) => new StoreLocator(pub ? publicClient : privateClient);
export default transactionsStoreLocator;
